module.exports = __webpack_public_path__ + "img/product_90.b6a35b1.webp";